export default __webpack_public_path__ + "static/media/nflStaff10.4c278220.jpg";